export default __webpack_public_path__ + "static/media/air-import-light.433a8ced.svg";